import {h} from 'preact'

const Loader = ({isVisible}) => (
  <div className={`loader ${isVisible && 'is-visible'}`}>
    <div className="spinner is-visible">
      <div className="rect1"></div>
      <div className="rect2"></div>
      <div className="rect3"></div>
      <div className="rect4"></div>
      <div className="rect5"></div>
    </div>
  </div>
)

export default Loader


// WEBPACK FOOTER //
// ./client/resources/js/checkout/components/loader.js